import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/index.css'

/**
 * 入口。
 *
 * 这里曾经有一层 Mock 后端：启动时按 `VITE_MOCK_BACKEND` 决定要不要替换
 * `window.fetch`，探测不到后端就整站换成假数据。**已整体删除。**
 *
 * 删掉的理由是它最危险的那个默认行为 `auto`：「探测不到后端」包含后端还没启动完、
 * 端口写错、数据库连不上这些情况，于是页面会静默变成一屏假数据，看起来一切正常。
 * 现在要对接真实后端，宁可看到错误态也不要看到假数据 —— 每个页面都自行处理
 * loading / empty / error 三态（AGENTS.md 6），错误会如实显示出来。
 *
 * 后端地址见 .env：开发期 `MODSITE_API_ORIGIN` 控制代理目标。
 */

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('找不到 #root 挂载点')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
